import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { WorkOrderComplementStatusNumber } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { useDisclosure } from '@/hooks';
import Authorities from '@/types/Authority';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import { Statistic, Tooltip } from 'antd';
import classNames from 'classnames';
import React from 'react';

interface Props {
  value?: number;
}

const WorkOrdersCancelledTotal: React.FC<Props> = ({ value }) => {
  const [viewWorkOrdersOpen, viewWorkOrdersActions] = useDisclosure();

  return (
    <>
      <div
        className={classNames('header-statistic-action', {
          '--disabled': !hasPermissions([
            Authorities.MOVIMENTATION_WORKORDER_VIEW,
          ]),
        })}
        onClick={viewWorkOrdersActions.open}
      >
        <Tooltip title="Total de orçamentos cancelados na base.">
          <Statistic value={value} title="Total de orçamentos" />
        </Tooltip>
      </div>

      <WorkOrdersListModal
        open={viewWorkOrdersOpen}
        onCancel={viewWorkOrdersActions.close}
        queryFilter={{
          status: [WorkOrderComplementStatusNumber.Cancelled],
        }}
      />
    </>
  );
};

export default WorkOrdersCancelledTotal;
